<template>
  <el-dialog class="exportPopover"
    width="500px"
    ref="exportPopover"
    :visible.sync="showModal_"
    title="Export Results"
    @close="resetComponent"
  >
    <div>
      <div v-if="!busy && !reportUrl">
        <p class="label">Filter your results further by selecting the date range of user actions.</p>

        <div class="dateRangeSelector">
          <p class="label"><b>Metric Date Range</b></p>

          <el-row>
            <neb-date-picker v-model="metricDateRange"
              :defaultOptions="datePickerDefaultOptions"
              prefix="Metric date range"
              mode="range"
              :defaultValue="[ '1970-01-01', today ]"
              clearable
              @clear="metricDateRange = [ '1970-01-01', today ]"
            ></neb-date-picker>
          </el-row>
        </div>
      </div>

      <div class="exportPopover-url" v-else-if="reportUrl && !busy">
        <img width="50" height="50" src="@assets/images/include.svg">

        <br>

        <object type="image/svg+xml" data="@assets/images/arrow-to-bottom-light.svg" class="icon"></object>

        <a class="exportPopover-url-href"
          target="_blank"
          :href="reportUrl"
        >
          Download Report
        </a>
      </div>

      <div class="exportPopover-progress" v-else>
        <p class="label" v-if="!finishing">Export Results in Progress...</p>

        <p class="label" v-if="finishing">Finishing up...</p>

        <el-progress :show-text="false"
          :stroke-width="18"
          :percentage="percentage"
        ></el-progress>
      </div>
    </div>

    <div slot="footer">
      <div v-if="!reportUrl">
        <el-button size="small"
          type="info"
          @click="() => showModal_ = false"
        >Cancel</el-button>

        <el-button class="exportButton"
          size="small"
          v-loading="busy"
          type="primary"
          :disabled="busy || reportUrl"
          @click="runExport"
        >
          <span :class="{ 'invisible': busy }">Export</span>
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import ApiClient from '@/components/api-client'
import { isUndefined } from 'lodash'
import moment from 'moment'
import { datePickerDefaultOptions } from '@/options'

export default {
  name: 'MeasureExportModal',

  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    queryParams: {
      type: Object,
      default: () => ({})
    }
  },

  data: () => ({
    metricDateRange: [ '1970-01-01', moment().format('YYYY-MM-DD') ],
    reportUrl: null,
    total: null,  // total number of assets in report
    done: null,  // number of assets that have been formatted for the report
    busy: false,
    showError: false,
    datePickerDefaultOptions,
    today: moment().format('YYYY-MM-DD'),
    timeoutId: null
  }),

  computed: {
    percentage () {
      if (this.done && this.total) {
        return parseInt(Math.ceil((this.done / this.total) * 100))
      }
      return 0
    },
    finishing () {
      if (this.done && this.total) {
        return this.done >= this.total
      }

      return false
    },
    'showModal_': {
      get () {
        return this.showModal
      },
      set () {
        this.$emit('update:showModal')
      }
    }
  },

  methods: {
    runExport () {
      this.busy = true

      return this.$store.dispatch('measure/initExport', this.queryParams)
        .then(({ data }) => {
          if (!isUndefined(data.file)) {
            this.reportUrl = data.file
            this.busy = false
          } else {
            this.total = 0
            return this.longPoll(data.taskId)
          }
        })
    },
    longPoll (taskId) {
      this.timeoutId = setTimeout(() => {
        ApiClient.getTaskCount(taskId).then(response => {
          this.done = response.data.count
          this.total = response.data.total
          if (!isUndefined(response.data.count)) {
            this.longPoll(taskId)
          } else if (!isUndefined(response.data.file)) {
            this.reportUrl = response.data.file
            this.busy = false
          }
        }).catch(() => {
          this.busy = false
          this.showError = true
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong while making the report',
            duration: 0
          })
        })
      }, 1500)
    },
    resetComponent () {
      this.reportUrl = null
    }
  },

  watch: {
    'queryParams.metricDateStart' (newValue) {
      this.metricDateRange = [ newValue, this.metricDateRange[1] ]
    },
    'queryParams.metricDateEnd' (newValue) {
      this.metricDateRange = [ this.metricDateRange[0], newValue ]
    }
  },

  beforeDestroy () {
    clearTimeout(this.timeoutId)
  }
}
</script>

<style lang="scss" scoped>
  .invisible {
    visibility: hidden;
  }
  .label {
    margin-top: 0;
    margin-bottom: 5px;
    font-size: 12px;
  }
  .dateRangeSelector {
    margin-top: 20px;
  }
  .exportPopover {
    &-url {
      margin-top: 10px;
      text-align: center;
      font-size: 12px;

      img {
        margin-bottom: 10px;
      }
      .icon {
        display: inline-block;
        vertical-align: middle;
        width: 14px;
        margin-right: 3px;

        color: #5acaec !important;
      }
    }
  }
</style>

<style lang="scss">
  .exportButton {
    .el-loading-mask {
      background: transparent;
    }
    .el-loading-spinner {
      margin-top: 7.5px;
      top: initial;
      svg {
        height: 16px; width: 16px;
        .path {
          stroke: white;
          stroke-width: 3;
        }
      }
    }
  }
</style>
